<script>
import InfosApi from '@/api/infos';
import { mapGetters } from 'vuex';

export default {
  name: 'Menu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    hideUserInfos: {
      type: Boolean,
      default: false
    },
    afficherLienAgrial: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    mini: true
  }),
  computed: {
    ...mapGetters({ _tiers: 'user/tiers', user: 'user/user' }),
    tiers () {
      return this._tiers || {};
    },
    currentRoute: {
      get () {
        return this.$route.name;
      }
    },
    itemsBottom () {
      return this.items.filter(i => !!i.bottomMenu);
    }
  },
  watch: {
    show (v) {
      this.showMenu = v;
    },
    showMenu (v) {
      this.$emit('update:show', v);
    }
  },
  methods: {
    navigateTo (pageName) {
      this.$router.push({ name: pageName });
    },
    hasRole (role) {
      if (!role) {
        return true;
      }
      return ~((this.user || {}).roles || []).indexOf(role);
    },
    goMonAgrial () {
      this.loading = true;
      InfosApi.getUrlPortail().then(url => {
        window.location.href = url;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<template>
  <fragment>
    <v-navigation-drawer
      v-model="showMenu"
      :permanent="!isMobile"
      :expand-on-hover="!isMobile"
      fixed
      mini-variant-width="70"
      color="primary"
      dark
      width="280"
    >
      <v-toolbar
        fixed
        color="primary"
        style="display:flex"
      >
        <v-icon
          large
          class="pointer'"
        >
          mdi-menu
        </v-icon>
      </v-toolbar>
      <v-list-item
        v-if="!hideUserInfos"
        three-line
      >
        <v-list-item-icon>
          <v-avatar size="50">
            <v-icon>mdi-account</v-icon>
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ tiers.raisonSociale }}</v-list-item-title>
          <v-list-item-subtitle>{{ tiers.numTiers }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="afficherLienAgrial"
        @click="goMonAgrial()"
      >
        <v-list-item-icon>
          <v-avatar size="50">
            <v-icon>mdi-home</v-icon>
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Mon Agrial</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="(item, index) in items">
        <v-divider
          v-if="item.divider"
          :key="index"
        />
        <v-list-item
          v-else-if="hasRole(item.role)"
          :key="item.route"
          @click="navigateTo(item.route)"
        >
          <v-list-item-icon>
            <v-avatar
              :class="{'primary darken-1':$route.name === item.route}"
              size="50"
            >
              <v-icon size="20">
                {{ item.icon }}
              </v-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.libelle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider />
    </v-navigation-drawer>
    <!--  { icon: 'mdi-history', page: 'main.catalog.order_history', title: 'Historique', state: 'ENABLED' },
      { icon: '$vuetify.icons.aliment', page: 'main.catalog.aliments', title: 'Aliments', state: 'ENABLED' },
      { icon: '$vuetify.icons.chicken', page: 'main.catalog.lots', title: 'Lots & plans', state: 'ENABLED' },
      { icon: '$vuetify.icons.contrat', page: 'main.catalog.contrats', title: 'Contrats', state: 'ENABLED' },
      -->
    <v-bottom-navigation
      v-if="isMobile"
      :value="currentRoute"
      grow
      active-class="nav-btn-active"
      color="secondary"
      fixed
      :hide-on-scroll="false"
    >
      <v-btn
        :value="null"
        style="display:none;"
      />
      <template v-for="item in itemsBottom">
        <v-btn
          v-if="hasRole(item.role)"
          :key="item.route"
          :value="item.route"
          :title="item.libelle"
          color="none"
          @click="navigateTo(item.route)"
        >
          <span>{{ item.libelle }}</span>
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </template>
    </v-bottom-navigation>
  </fragment>
</template>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-image: url("../assets/images/bg-nav.svg");
  background-position: left bottom;
  background-repeat: no-repeat;
  z-index: 1000;
  &>*{
    background-color: var('primary')
  }
}
@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .v-navigation-drawer {
    background-image: none;
  }
}

.v-list-item, .v-list-group, .v-divider {
  background-color: var(--v-primary-base);
}

.v-list-item {
  padding: 0 10px;
  .v-list-item__icon {
    margin: 10px 0;
  }
  .v-list-item__content {
    margin-left: 16px;
    align-items: flex-start;
  }
}
.v-list-group {
  padding: 0 10px;
}

.v-list-group .v-list-item {
  margin-left: 2em;
}

.v-icon {
  border-radius: 0;
}

.v-navigation-drawer ::v-deep .v-badge__badge{
  inset: auto !important;
}
</style>
